import React, { useEffect, useState } from "react";
import { Divider, Grid, Stack, Typography, Box } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ArticleIcon from "@mui/icons-material/Article";
import GppGoodIcon from "@mui/icons-material/GppGood";
import AdbIcon from "@mui/icons-material/Adb";
import AppleIcon from "@mui/icons-material/Apple";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
import IconButton from "@mui/material/IconButton";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useContext } from "react";
import { ConfigLinksDetailsContext } from "../Context/cofingLinksDetailsContext";
import { useNavigate } from "react-router";
import { min } from "lodash";
import { useTranslation } from "react-i18next";

const AppFooter = () => {
  const { configLinks } = useContext(ConfigLinksDetailsContext);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const onClick = (link) => {
    link &&
      window.open(
        link,
        "_blank" // <- This is what makes it open in a new window.
      );
  };
  return (
    <Box
      component="footer"
      sx={{
        marginTop: "auto",
        paddingTop: "40px",
        paddingBottom: { xs: "calc(160px + env(safe-area-inset-bottom))", sm: "48px" },
      }}
    >
      <Grid spacing={3} container justifyContent="center" sx={{ maxWidth: "1200px", margin: "0 auto" }}>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
          md={4}
          xs={12}
          item
        >
          <Stack gap={1} alignItems="center">
            <Stack alignItems="center">
              <Typography sx={{ fontWeight: "bold" }} color="primary.main">
                {t('footer_policies')}
              </Typography>
              <Divider sx={{ width: "150px" }} />
            </Stack>
              <Stack alignItems="center" gap={1} direction="row" sx={{ cursor: "pointer" }} onClick={() => navigate("/privacy-and-protection")}>
              <GppGoodIcon color="primary" />
              <Typography>{t('privacyPolicy')}</Typography>
            </Stack>
            <Stack
              alignItems="center"
              gap={1}
              direction="row"
              sx={{ cursor: "pointer" }}
              onClick={() => navigate("/terms-and-conditions")}
            >
              <ArticleIcon color="primary" />
              <Typography>{t('termsAndConditions')}</Typography>
            </Stack>

          </Stack>
        </Grid>
        <Grid
          md={4}
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
          item
        >
          <Stack gap={1} alignItems="center">
            <Stack alignItems="center">
              <Typography sx={{ fontWeight: "bold" }} color="primary.main">
                {t('footer_downloadApp')}
              </Typography>
              <Divider sx={{ width: "150px" }} />
            </Stack>
            <Stack gap={2} direction="row" justifyContent="center">
              <IconButton onClick={() => onClick(configLinks.android)}>
                <AdbIcon color="primary" />
              </IconButton>
              <IconButton onClick={() => onClick(configLinks.appStore)}>
                <AppleIcon color="primary" />
              </IconButton>
            </Stack>
          </Stack>
        </Grid>
        <Grid
          md={4}
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
          item
        >
          <Stack gap={1} alignItems="center">
            <Stack alignItems="center">
              <Typography sx={{ fontWeight: "bold" }} color="primary.main">
                {t('footer_socialMedia')}
              </Typography>
              <Divider sx={{ width: "150px" }} />
            </Stack>
            <Stack gap={2} direction="row" justifyContent="center">
              <IconButton onClick={() => onClick(configLinks.facebook)}>
                <FacebookIcon color="primary" />
              </IconButton>
              <IconButton onClick={() => onClick(configLinks.whatsapp)}>
                <WhatsAppIcon color="primary" />
              </IconButton>
            </Stack>
          </Stack>
        </Grid>
                     <Box
        component="div"
        sx={{
          py: 1,
          mt: 3,
          // backgroundColor: "#f5f5f5",
          borderTop: "1px solid #e0e0e0",
          width: "100%",
          // position: "relative",
          // left: "0",
          // right: "0",
           bottom: "0",
        }}
      >
        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          sx={{ fontSize: "0.875rem" }}
        >
          © {new Date().getFullYear()} {(i18n.language === 'ar' ? configLinks?.municipalityNameAr : configLinks?.municipalityNameEn) || t('footer_municipality')} - {t('footer_allRightsReserved')}
        </Typography>
      </Box>
      </Grid>
    </Box>
  );
};
export default AppFooter;
